import * as Styled from './Drawer.styles';
import { Divider } from '@mui/material';
import { useSelectCurveManager } from '../../../selectors';
import React from 'react';
/**
 * Opens if passed drawerId === the drawer string in redux state
 */
const Drawer = ({ children, drawerId, title, footer, onClickAway }) => {
    const selectedCurveManager = useSelectCurveManager();
    const handleClickAway = () => {
        if (onClickAway)
            onClickAway();
    };
    return (React.createElement(Styled.Drawer, { anchor: "right", open: selectedCurveManager.dialog === drawerId, classes: { paper: 'innovyze-drawer-paper' }, ModalProps: { onBackdropClick: handleClickAway } },
        title && (React.createElement(React.Fragment, null,
            React.createElement(Styled.Title, { color: "primary", variant: "heading-medium-strong" }, title),
            React.createElement(Divider, null))),
        React.createElement(Styled.DrawerBody, { "data-cy": "sideBar" }, children),
        footer && (React.createElement(React.Fragment, null,
            React.createElement(Divider, null),
            footer))));
};
//Default Props
Drawer.defaultProps = {
    open: false,
    workspace: {
        id: 0,
        name: '',
        description: '',
    },
    workspaceErrors: [],
};
export default Drawer;
